import http from '@/utils/services/http'
// import {response} from "express";

export function prerequisitosLista (tipoGrv = null) {
  let url = '/api/grv/dataRequiredGrvList?tipoGrv=' + tipoGrv
  console.log(url)
  return http.get(url)
    .then(response => Promise.resolve(response))
    .catch(({response}) => Promise.reject(response))
}

export function lista (limit, page, filtros) {
  let url = '/api/grv?page=' + page + '&limit=' + limit + filtros
  console.log(url)
  return http.get(url)
    .then(response => Promise.resolve(response))
    .catch(({response}) => Promise.reject(response))
}

export function emitirSegundaVia (grv) {
  return http.get(`/api/grv/${grv}/segunda-via`, {responseType: 'blob'})
    .then(response => Promise.resolve(response))
    .catch(({response}) => Promise.reject(response))
}

export function emitirDocumentoRetirada (grv) {
  return http.get(`/api/grv/${grv}/emitir-documento-retirada`, {responseType: 'blob'})
    .then(response => Promise.resolve(response))
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export function emitirDocumentoRetiradaLeilao (grv) {
  return http.get(`/api/grv/${grv}/emitir-declaracao-retirada-leilao`, {responseType: 'blob'})
    .then(response => Promise.resolve(response))
    .catch(({response}) => Promise.reject(response))
}

export function emitirGuiaPagamento (idPreretirada, data) {
  return http.post(`/api/grv/preretirada/${idPreretirada}/comprovante-apl`, JSON.stringify(data), {responseType: 'blob'})
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export function excluirLote (grv) {
  return http.delete(`/api/grv/${grv}/excluir-lote`)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export function custos (id, dataNotificacao = null, dataDiariasInicial = null, dataDiariasFinal = null, dataGratuidade = null) {
  return http.get(`/api/grv/${id}/calculo?dataNotificacao=${dataNotificacao}&dataDiariasInicial=${dataDiariasInicial}&dataDiariasFinal=${dataDiariasFinal}&dataGratuidade=${dataGratuidade}`)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export function buscaCep (cep) {
  const authorization = http.defaults.headers.common['Authorization']
  delete http.defaults.headers.common['Authorization']
  return http.get('https://viacep.com.br/ws/' + cep + '/json')
    .then(response => {
      http.defaults.headers.common['Authorization'] = authorization
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      http.defaults.headers.common['Authorization'] = authorization
      return Promise.reject(response)
    })
}

export function deleteGrv (id, motivo) {
  return http.post(`/api/grv/${id}/delete`, {motivo})
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export function verificarEfeitosColateraisDelete (id) {
  return http.get(`/api/grv/${id}/checar-efeitos-colaterais-delete`)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export function detroLogs (id) {
  return http.get(`/api/grv/${id}/logDetro`)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export function pagarPreretirada (id, dados) {
  return http.post('/api/grv/pagarPreretirada/' + id, dados)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export function cancelarPreretirada (id, motivo) {
  return http.post('/api/grv/cancelarPreretirada/' + id, {motivo})
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export function consultaPagamentoBoleto (referencia) {
  return http.get(`/api/preretirada/consultaPagamento/${referencia}`)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export function emitirDeclaracaoDeAcessoAoVeiculo (grv, data) {
  return http.post(`/api/grv/declaracao/acesso/${grv}`, JSON.stringify(data), {responseType: 'blob'})
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export function corrigirEstadas (grv, quantidade, quantidadeAnterior) {
  return http.patch(`/api/grv/${grv}/corrigir-estadas`, JSON.stringify({quantidade, quantidadeAnterior}))
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export function getHistoricoLeiloesGrv (grvId) {
  return http.get(`/api/grv/${grvId}/historico-leiloes`)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export function verificaNumeroGrv (numero) {
  return http.get(`/api/grv/verifica-numero-grv?numero=${numero}`)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export function uploadFotoGrvIndividual (grvId, data) {
  return http.post(`/api/grv/${grvId}/cadastrar-foto-individual-admin`, data)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export function uploadArquivoScan (grvId, data) {
  return http.post(`/api/grv/${grvId}/upload-arquivo-scan`, data)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export function deleteArquivoGrv (arquivoId) {
  return http.delete(`/api/grv/arquivo/${arquivoId}`)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export function getPublicLinkS3 (fileId) {
  return http.get(`/api/grv/download-foto-grv?file=${fileId}`)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export function emitirGev (ggv) {
  return http.get(`/api/ggv/${ggv}/emitir-gev`, {responseType: 'blob'})
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export function consultaPlacaChassiPolicia (placaChassi, tipo) { // TODO: IMPLEMENTAÇÃO TEMPORÁRIA
  // console.log('placa-chassi: ' + JSON.stringify(placaChassi))
  return http.post(`/api/grv/consultaPlacaChassiPolicia`, JSON.stringify({placaChassi, tipo}), {timeout: 7000})
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export function alterarStatus (grv, status) {
  return http.patch(`/api/grv/${grv}/alterar-status`, JSON.stringify({status}))
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export function alterarRegraMeioDia (grv, desativar) {
  return http.patch(`/api/grv/${grv}/alterar-regra-meio-dia`, JSON.stringify({desativar}))
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export function getArrematanteGrv (grvId) {
  return http.get(`/api/grv/${grvId}/get-arrematante`)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export function autorizarRetiradaPolicia (grvId, tipo = 'retirada') {
  return http.patch(`/api/grv/${grvId}/autorizar-retirada-policia`, {tipo})
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export function bloquearParaLeilao (grvId, bloquear = true, motivo = null) {
  return http.patch(`/api/grv/${grvId}/bloquear-para-leilao`, JSON.stringify({bloquear, motivo}))
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export function checarInformacoesBloqueioGrv (grvId) {
  return http.get(`/api/grv/${grvId}/informacoes-grv-bloqueio`)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export function checaAutorizarRetiradaPolicia (grvId) {
  return http.get(`/api/grv/${grvId}/checa-autorizar-retirada-policia`)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export function listSemGgv (id = 505) {
  return http.get(`/api/grv/${id}/lista-grvs-semGgv`)
    .then(response => {
      // Retorne apenas os dados, que devem ser um array de GRVs
      return Promise.resolve(response.data) // Isso deve conter os dados da GRV
    })
    .catch(({ response }) => {
      console.error('Erro ao buscar GRVs:', response)
      return Promise.reject(response) // Rejeita com a resposta de erro
    })
}

export function marcarChegou (id) {
  return http.post(`/api/grv/${id}/chegou`)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export default {
  dataRequired (tipoGrv, filtrosCustomizados = '') {
    return http.get(`/api/grv/dataRequired?reboquistas=true&reboques=true&equipamentos=true&orgaoApreensor=true&tipoArquivo=true${filtrosCustomizados}${tipoGrv !== null ? '&tipoGrv=' + tipoGrv : ''}`)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  cadastro (grv, id, tipoGrv) {
    if (typeof id !== 'undefined') {
      return this.atualizacao(grv, id, tipoGrv)
    }
    return http.post('/api/grv?tipoGrv=' + tipoGrv, grv)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  atualizacao (data, id, tipoGrv) {
    return http.patch('/api/grv/' + id + '?tipoGrv=' + tipoGrv, data)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  find (id, ggv, dadosExtras) {
    ggv = typeof ggv !== 'undefined' ? ggv : false
    dadosExtras = typeof dadosExtras !== 'undefined' ? dadosExtras : false
    id = parseInt(id)
    if (id < 1) return Promise.reject()
    return http.get('/api/grv/' + id + '?dadosExtras=' + dadosExtras + (ggv ? '&ggv=1' : ''))
      .then(response => {
        console.log(response)
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  consultaPlacaChassi (placaChassi) {
    // console.log('placa-chassi: ' + JSON.stringify(placaChassi))
    return http.post(`/api/grv/consultaPlacaChassi`, JSON.stringify(placaChassi))
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  listaSimples (filtro, patio = 0) {
    return http.get(`/api/grv/lista-simples?filtro=${filtro}&patio=${patio}`)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  gerarNumeroGrvPoliciaCivil () {
    return http.get(`/api/grv/gerar-numero-grv-policia-civil`)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  listarEquipamentosPorCategoria (categoria) {
    console.log('categoria: ' + categoria)
    return http.get(`/api/equipamentos/categoria/${categoria}`)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  }
}



// WEBPACK FOOTER //
// ./src/domain/grv/services/index.js